/**
 * The DISPLAY bucket for a serve row — the one label a card header or tally
 * row shows for "which group is this?".
 *
 * School quantity rows are bucketed by the campus policy's serve group (the
 * server-resolved line tuple — age-group column, grade, homeroom, …), and
 * parent student cards by the student's matching Enrollment fact. Both arrive
 * as `groupLabel` (roster rebuild Phase 5); the legacy fields —
 * `gradeGroupName ?? rosterName` for school rows, `gradeRangeName ??
 * rosterName` for student groups — remain the fallback for pre-flip rows.
 *
 * FILTERING is a different question and lives in `serve-filters.ts`: it must
 * split these same rows onto a grade axis and a homeroom axis, which this
 * single collapsed label cannot answer.
 */

export interface DeliverableRowBucket {
  gradeGroupName: string | null
  rosterName: string | null
  /** Server-resolved serve-group label (tuple-first); preferred when present. */
  groupLabel?: string | null
}

export interface StudentGroupBucket {
  gradeRangeName: string | null
  rosterName: string | null
  /** Server-resolved serve-group label (Enrollment facts); preferred when present. */
  groupLabel?: string | null
}

/** School quantity-row bucket: the resolved serve group, legacy fallback. */
export function bucketForDeliverableRow(row: DeliverableRowBucket): string | null {
  return row.groupLabel ?? row.gradeGroupName ?? row.rosterName
}

/** Parent student-card bucket: the resolved serve group, legacy fallback. */
export function bucketForStudentGroup(group: StudentGroupBucket): string | null {
  return group.groupLabel ?? group.gradeRangeName ?? group.rosterName
}
